import React from 'react';
import Image from 'next/image';

import Checkers from '../../../../helpers/class/Checkers';

function widthClassesForCount ( count ) {
  if ( count <= 4 ) {
    const md = Math.round( 12 / count );
    const sm = Math.round( ( 12 / count ) * 2 );
    const cls = `col-md-${md} col-sm-${sm} col-xs-12`;
    return { master: cls, prePrePreLast: cls, prePreLast: cls, preLast: cls, last: cls };
  }
  if ( count % 5 === 0 ) {
    return {
      master: 'col-md-4 col-sm-6 col-xs-12',
      prePrePreLast: 'col-md-4 col-sm-6 col-xs-12',
      prePreLast: 'col-md-4 col-sm-6 col-xs-12',
      preLast: 'col-md-6 col-sm-6 col-xs-12',
      last: 'col-md-6 col-sm-6 col-xs-12'
    };
  }
  if ( count % 6 === 0 ) {
    const cls = 'col-md-4 col-sm-6 col-xs-12';
    return { master: cls, prePrePreLast: cls, prePreLast: cls, preLast: cls, last: cls };
  }
  if ( count % 4 === 0 ) {
    const cls = 'col-md-3 col-sm-6 col-xs-12';
    return { master: cls, prePrePreLast: cls, prePreLast: cls, preLast: cls, last: cls };
  }
  if ( count === 7 || count === 11 ) {
    return {
      master: 'col-md-3 col-sm-12 col-xs-12',
      prePrePreLast: 'col-md-3 col-sm-12 col-xs-12',
      prePreLast: 'col-md-4 col-sm-12 col-xs-12',
      preLast: 'col-md-4 col-sm-12 col-xs-12',
      last: 'col-md-4 col-sm-12 col-xs-12'
    };
  }
  if ( count === 9 ) {
    return {
      master: 'col-md-2 col-sm-4 col-xs-12',
      prePrePreLast: 'col-md-2 col-sm-4 col-xs-12',
      prePreLast: 'col-md-4 col-sm-4 col-xs-12',
      preLast: 'col-md-4 col-sm-4 col-xs-12',
      last: 'col-md-4 col-sm-4 col-xs-12'
    };
  }
  const cls = 'col-md-4 col-sm-6 col-xs-12';
  return { master: cls, prePrePreLast: cls, prePreLast: cls, preLast: cls, last: cls };
}

function widthClassForIndex ( index, count, classes ) {
  const revindex = count - index;
  if ( revindex === 1 ) return classes.last;
  if ( revindex === 2 ) return classes.preLast;
  if ( revindex === 3 ) return classes.prePreLast;
  if ( revindex === 4 ) return classes.prePrePreLast;
  return classes.master;
}

const CHANNEL_LOGO_HEIGHT = {
  12: 95,
  2: 45,
  32: 45,
  5: 35,
  11: 35,
  20: 35,
  33: 35,
  3: 20,
  26: 35,
  22: 37
};

function logoHeightForChannel ( systemChannelId ) {
  return CHANNEL_LOGO_HEIGHT[systemChannelId] != undefined ? CHANNEL_LOGO_HEIGHT[systemChannelId] : 25;
}

const ROW_HEIGHT = 95;

export default function PartnersSection ( props ) {

  const partnerLinks = Checkers.isValidArray( props.content?.partnerLinks ) ? props.content.partnerLinks : [];

  if ( partnerLinks.length === 0 ) {
    return null;
  }

  const classes = widthClassesForCount( partnerLinks.length );

  return (
      <section className="p-t-10 p-b-10 text-center">
        <div className="container">
          <div className="md-p-l-20 xs-no-padding clearfix">
            <div className="row row-eq-height">
              {
                partnerLinks.map( ( partnerLink, index ) => {
                  const widthClass = widthClassForIndex( index, partnerLinks.length, classes );
                  const height = logoHeightForChannel( partnerLink.systemChannelId );
                  const marginTop = Math.floor( ( ROW_HEIGHT - height ) / 2 );

                  return (
                      <div className={widthClass + ' no-padding'} style={{ height: ROW_HEIGHT }} key={partnerLink.id}>
                        <a href={partnerLink.link} target="_blank" rel="noreferrer" style={{ color: '#626262' }}>
                          <div className="p-r-40 md-pr-30 xs-no-padding clearfix" style={{ marginTop }}>
                            <div className="position-relative mx-auto" style={{ height, maxWidth: 200 }}>
                              <Image
                                  src={'/assets/img/partners/' + partnerLink.systemChannelId + '.jpg'}
                                  alt={partnerLink.title || 'partner'}
                                  layout="fill"
                                  sizes="200px"
                                  objectFit="contain"
                                  style={{ mixBlendMode: 'multiply' }}
                              />
                            </div>
                          </div>
                          <div className="d-md-none" style={{ borderBottom: '1px solid #e5e5e5', width: '80%', margin: '24px auto 0' }}/>
                          <span className="hidden">{partnerLink.title}</span>
                        </a>
                      </div>
                  );
                } )
              }
            </div>
          </div>
        </div>
      </section>
  );
}
